import FlowBpmPage from "../../pages/flowBpm/FlowBpmPage";

const route = {
  key: "flowBpm",
  path: "/flow-bpm",
  component: FlowBpmPage,
  permission: "flow-bpm.task.read",
  private: true,
  layout: "main",
  icon: "faDiagramProject",
  group: "sales",
  order: 18,
};

export default route;

